import Modal from "../common/classes/modal";

const fontListModalBtn = document.querySelector(".font-list-container");

const toggleFontListModal = () => {
  fontListModalBtn.classList.toggle("show");
};

const modal = new Modal({
  elementId: "font-modal",
  onOpenCallback: () => {
    toggleFontListModal();
  },
  onCloseCallback: () => {
    toggleFontListModal();
  },
});

const openFontListModal = ({ callback = () => {} } = {}) => {
  modal.open(() => {
    callback();
  });
};

export default openFontListModal;